interface Price {
  displaySalePrice: boolean;
  saleStartDate?: string;
  saleEndDate?: string;
}

export default ({
  displaySalePrice,
  saleStartDate,
  saleEndDate,
}: Price): boolean => {
  const currentDate = new Date();

  return (
    displaySalePrice &&
    new Date(String(saleStartDate)) < currentDate &&
    currentDate < new Date(String(saleEndDate))
  );
};
